import React from 'react'
import Header from './home/Header';
import MyRewards from './home/MyRewards'

import Points from './home/Points'
import Referrals from './home/Referrals'


const Index = (props) => {
	
	const { points } = props.data;
	
	const {onClick, launcherFlag, availableCodeCount, data, email, visitorId} = props
	return (
		<div>
			<Header points={ points } onClick={onClick} launcherFlag= {launcherFlag}/>
			<div className="panel-container with-wantdo-footer">
				<div className="home-view-container">
					{
						availableCodeCount > -1 ?
							<MyRewards availableCodeCount={availableCodeCount} email={email} visitorId={visitorId}/>
							:
							''
					}

					<Points points={ points } email={email} visitorId= {visitorId}/>
					<Referrals availableCodeCount={availableCodeCount} data={data} email={email} visitorId= {visitorId}/>
				</div>
			</div>
		</div>


	)
}

export default Index;